/**
 * History Timeline — front end. Wires the previous/next buttons to the card
 * scroller, disables them at either end, and hides them when every card fits.
 */
( function () {
	// Pixels of slack at either end (sub-pixel rounding, snap offsets).
	const EDGE = 4;

	document.querySelectorAll( '.dlb-history' ).forEach( function ( section ) {
		const track = section.querySelector( '.dlb-history__track' );
		const controls = section.querySelector( '.dlb-history__controls' );
		if ( ! track || ! controls ) {
			return;
		}
		const prev = controls.querySelector( '[data-dir="-1"]' );
		const next = controls.querySelector( '[data-dir="1"]' );

		function update() {
			const max = track.scrollWidth - track.clientWidth;
			controls.hidden = max <= EDGE;
			prev.disabled = track.scrollLeft <= EDGE;
			next.disabled = track.scrollLeft >= max - EDGE;
		}

		controls.addEventListener( 'click', function ( e ) {
			const button = e.target.closest( '[data-dir]' );
			if ( ! button ) {
				return;
			}
			// One card (plus the gap) per click.
			const card = track.querySelector( '.dlb-hcard' );
			const list = track.querySelector( '.dlb-history__list' );
			const gap =
				parseFloat( window.getComputedStyle( list ).columnGap ) || 0;
			const step = card
				? card.offsetWidth + gap
				: track.clientWidth * 0.8;
			track.scrollBy( {
				left: step * Number( button.dataset.dir ),
				behavior: 'smooth',
			} );
		} );

		track.addEventListener( 'scroll', update, { passive: true } );
		window.addEventListener( 'resize', update );
		update();
	} );
} )();
